import React from "react";

function PackagingnDispenser() {
  return <div>PackagingnDispenser</div>;
}

export default PackagingnDispenser;
